// @flow

import * as React from 'react';
import styles from './SiteCardList.module.css';

type Props = {
  children: React.Node,
};

const SiteCardList = ({ children }: Props) => (
  <div className={styles.root}>{children}</div>
);

export default SiteCardList;
